import React, { useImperativeHandle, useState } from "react";
import { Button, Input, } from "../Elements";
import Modal from "../Modal";
import { useDispatch } from 'react-redux';
import { updateField } from "../../../store/slices/customerListSlice"
import { isValidEmailAddress, isValidPhoneNumber } from "../../../common/helpers/globalHelpers";

const UpdateRowModal = React.forwardRef((props, ref) => {
    const dispatch = useDispatch();
    const [isModalVisible, setIsModalVisible] = useState(false);

    const [fields, setFields] = useState({
        requestamount: 0,
        linkdesc: "",
        sendtype: -1,
        phone: "",
        email: "",
        lastlinkdate: "",
        customerName: "",
        customerCode: "",



    }); 
    useImperativeHandle(ref, () => ({

        openModal(defaultValues) {
            setFields(defaultValues);
            setIsModalVisible(true);
        }

    }));

    const onUpdateClick = () => {


        dispatch(updateField({
            ...fields
        }));
        setIsModalVisible(false);
    }

    const isValidPhone =()=>{ 
       

        if (fields.phone) {
            var phoneStatus = isValidPhoneNumber(fields.phone);
            if (phoneStatus) {
                return "";
            } else {
                return "Lütfen telefon numarasını doğru formatta giriniz.";
            } 
        } else {
            return false;
        } 
    }
    
    const isValidEmail =()=>{
        if (fields.email) {
            var mailStatus = isValidEmailAddress(fields.email); 
            if (mailStatus) {
                return "";
            } else {
                return "Lütfen Email adresini doğru formatta giriniz.";
            } 
        } else {
            return "";
        } 
    }

    const onChangeField = (event) => {
 
      
        setFields({
            ...fields,
            [event.target.name]: event.target.value
        });
    }
 
    return (
        <Modal openModal={isModalVisible} setOpenModal={() => setIsModalVisible(false)} >
            <div>
                <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-[100%]">
                        <h3 className="text-md leading-6 font-medium text-gray-900">
                            {fields.customername} Güncelle

                        </h3>
                        <div className="w-100">
                        
                                <div className="mt-4">
                                    <Input
                                        name={`requestamount`}
                                        value={fields.requestamount}
                                        // type="number"
                                        className=" w-[100%]"
                                        label="Ödeme Talebi Bakiyesi"
                                        // onValueChange={onChangeMoneyField}
                                        onChange={onChangeField}
                                        required
                                        currencyformat="true"
                                        currencyicon="true"
                                        defaultValue="0.00"
                                        isTRCurrencyDisplay={true}
                                    />
                                </div> 
                                <div className="mt-4">
                                    <Input
                                        name={`phone`}
                                        value={fields.phone}
                                        type="text"
                                        className="w-[100%]"
                                        label="Telefon"
                                        onChange={onChangeField}
                                        required
                                        error={isValidPhone()}
                                    />
                                </div>

                                <div className="mt-4">
                                    <Input
                                        name={`email`}
                                        value={fields.email}
                                        type="text"
                                        className="w-[100%]"
                                        label="Email"
                                        onChange={onChangeField}
                                        required
                                        error={isValidEmail()}
                                    />
                                </div>
                                
                                <div className="mt-4">
                                    <Input
                                        name={`linkdesc`}
                                        value={fields.linkdesc}
                                        type="text"
                                        className=" w-[100%]"
                                        label="Ödeme Açıklaması"
                                        onChange={onChangeField} 
                                    />
                                </div>
                            </div>           
                    </div>
                </div>
                <div className="mt-5 mt-4 flex justify-end space-x-2">
                    <Button
                        color="gray"
                        hover="gray"
                        size="xs"
                        callback={() => setIsModalVisible(false)}
                    >
                        İptal
                    </Button>
                    <Button
                        color="primary"
                        hover="primary"
                        size="xs"
                        callback={() => {
                            onUpdateClick();
                        }}
                    >
                        Kaydet
                    </Button>
                </div>
            </div>
        </Modal>
    );
})

export default UpdateRowModal;